export default __webpack_public_path__ + "static/media/Skeleton-3D-Model-01.7b052891.jpg";